<div class="footer-bottom navbar-fixed-bottom nonPrintable">
    <div class="container">
        <div class="row">
            <div class="col-md-12 widget">
                <span>{{'Copyright' | translate}} </span>
                <span>{{ currentYear }} </span>
                <span>{{ 'Amanah Teknologia. All Rights Reserved.' | translate}}</span>
            </div>
        </div>
    </div>
</div>
